import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "BatteryCharged.svg",
  "use": "BatteryCharged.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"BatteryCharged.svg\"><path d=\"M57.0208,37.0209a1,1,0,0,1-1-1v-8a1,1,0,0,1,1-1,3,3,0,0,1,3,3v4A3,3,0,0,1,57.0208,37.0209Zm-7-17a4,4,0,0,1,4,4v16a4,4,0,0,1-4,4h-40a4,4,0,0,1-4-4v-16a4,4,0,0,1,4-4Zm-32,13h4c4.0259,0,3.86,6,10,6h3v-3h5a1,1,0,1,0,0-2h-5v-4h5a1,1,0,1,0,0-2h-5v-3h-3c-6.14,0-5.974,6-10,6h-4a1,1,0,0,0,0,2Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol